module.exports = __webpack_public_path__ + "img/mortgages-providers1.80624a0.png";